import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-tabs',
	imports: [SharedModule, TabsComponent, UiCodeBlockComponent],
	templateUrl: './ui-tabs.component.html',
	styleUrl: './ui-tabs.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTabsComponent {
	// Type 1 - Text only tabs
	textOnlyTabs: any[] = [{ label: 'Inicio' }, { label: 'Perfil' }, { label: 'Configuración' }];

	// Type 2 - Pills with icons
	iconTabs: any[] = [
		{ label: 'Configuración General', icon: 'settings' },
		{ label: 'Empresa', icon: 'building-2' },
		{ label: 'Usuarios', icon: 'users-round' },
		{ label: 'Materiales', icon: 'tool-case' },
		{ label: 'Ausencias', icon: 'clipboard-list' },
	];

	// Type 3 - Flag style with images
	companyTabs: any[] = [
		{ label: 'España', icon: 'assets/layout/images/esp.png' },
		{ label: 'Andorra', icon: 'assets/layout/images/and.png' },
		{ label: 'Francia', icon: 'assets/layout/images/esp.png' },
	];

	// Fit content examples
	fitContentTabs: any[] = [{ label: 'Corto' }, { label: 'Texto Muy Largo de Ejemplo' }];

	// Icon only tabs
	iconOnlyTabs: any[] = [
		{ label: 'Inicio', icon: 'home' },
		{ label: 'Perfil', icon: 'user' },
		{ label: 'Configuración', icon: 'settings' },
		{ label: 'Notificaciones', icon: 'bell' },
		{ label: 'Ayuda', icon: 'help-circle' },
	];

	// Type 1 states
	selectedTabType1 = 0;
	selectedTabType1IconOnly = 0;

	// Type 2 states
	selectedTabType2Large = 0;
	selectedTabType2Medium = 0;
	selectedTabType2Small = 0;
	selectedTabType2XSmall = 0;
	selectedTabType2IconOnlyLarge = 0;
	selectedTabType2IconOnlyMedium = 0;
	selectedTabType2IconOnlySmall = 0;
	selectedTabType2IconOnlyXSmall = 0;

	// Type 3 states
	selectedTabType3Large = 0;
	selectedTabType3Medium = 0;
	selectedTabType3Small = 0;
	selectedTabType3XSmall = 0;
	selectedTabType3IconOnly = 0;

	// Fit content states
	selectedTabFitDefault = 0;
	selectedTabFitContent = 0;

	// Type 1 handlers
	onTabChangeType1(index: number): void {
		this.selectedTabType1 = index;
	}

	onTabChangeType1IconOnly(index: number): void {
		this.selectedTabType1IconOnly = index;
	}

	// Type 2 handlers
	onTabChangeType2Large(index: number): void {
		this.selectedTabType2Large = index;
	}

	onTabChangeType2Medium(index: number): void {
		this.selectedTabType2Medium = index;
	}

	onTabChangeType2Small(index: number): void {
		this.selectedTabType2Small = index;
	}

	onTabChangeType2XSmall(index: number): void {
		this.selectedTabType2XSmall = index;
	}

	onTabChangeType2IconOnlyLarge(index: number): void {
		this.selectedTabType2IconOnlyLarge = index;
	}

	onTabChangeType2IconOnlyMedium(index: number): void {
		this.selectedTabType2IconOnlyMedium = index;
	}

	onTabChangeType2IconOnlySmall(index: number): void {
		this.selectedTabType2IconOnlySmall = index;
	}

	onTabChangeType2IconOnlyXSmall(index: number): void {
		this.selectedTabType2IconOnlyXSmall = index;
	}

	// Type 3 handlers
	onTabChangeType3Large(index: number): void {
		this.selectedTabType3Large = index;
	}

	onTabChangeType3Medium(index: number): void {
		this.selectedTabType3Medium = index;
	}

	onTabChangeType3Small(index: number): void {
		this.selectedTabType3Small = index;
	}

	onTabChangeType3XSmall(index: number): void {
		this.selectedTabType3XSmall = index;
	}

	onTabChangeType3IconOnly(index: number): void {
		this.selectedTabType3IconOnly = index;
	}

	// Fit content handlers
	onTabChangeFitDefault(index: number): void {
		this.selectedTabFitDefault = index;
	}

	onTabChangeFitContent(index: number): void {
		this.selectedTabFitContent = index;
	}

	generateCode(attrs: {
		tabHeaders?: string;
		type?: string;
		size?: string;
		selectedTab?: string;
		selectedTabChange?: string;
		iconOnly?: boolean;
		fitContent?: boolean;
	}): string {
		let code = '<app-tabs';

		if (attrs.tabHeaders) code += `\n    [tabHeaders]="${attrs.tabHeaders}"`;
		if (attrs.type) code += `\n    type="${attrs.type}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.iconOnly) code += `\n    [iconOnly]="true"`;
		if (attrs.fitContent !== undefined) code += `\n    [fitContent]="${attrs.fitContent}"`;
		if (attrs.selectedTab) code += `\n    [selectedTab]="${attrs.selectedTab}"`;
		if (attrs.selectedTabChange) code += `\n    (selectedTabChange)="${attrs.selectedTabChange}"`;

		code += '\n/>';
		return code;
	}

	generateTabDataStructure(): string {
		return `tabHeaders = [
  {
    labelKey: 'tab.label.key',
    icon: 'assets/icons/icon.png' // optional
  },
  {
    labelKey: 'another.tab.label',
    icon: 'Home' // lucide icon name
  }
];`;
	}
}
